import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { useMemo } from 'react';

import { Gallery } from './components/Gallery';
import { WIDGET_DEFAULT_ATTRIBUTES } from './constants';
import { GalleryAttributes } from './widgets/gallery/types';
import { getDisplayOptions } from './widgets/gallery/utils';
import { WidgetWrapper } from './WidgetWrapper';
import { Widget } from '../utils/enums/embed';

interface Props {
  apolloClient: ApolloClient<NormalizedCacheObject>;
  attributes: GalleryAttributes;
}

export const GalleryWidget = ({ apolloClient, attributes }: Props) => {
  const displayOptions = useMemo(
    () => getDisplayOptions(attributes),
    [attributes]
  );

  return (
    <WidgetWrapper
      apolloClient={apolloClient}
      dialogParams={{
        cookieConsent:
          attributes.cookieConsent ?? WIDGET_DEFAULT_ATTRIBUTES.cookieConsent,
        widgetType: Widget.Gallery,
        platform: attributes.platform,
      }}
    >
      <Gallery
        company={attributes.company}
        id={attributes.moduleId}
        displayOptions={{
          animations: displayOptions.animations,
          border: displayOptions.border,
          borderColor: displayOptions.borderColor,
          display: displayOptions.display,
          font: displayOptions.font,
          gap: displayOptions.gap,
          justify: displayOptions.justify,
          withPlayIcon: displayOptions.withPlayIcon,
          withRadius: displayOptions.withRadius,
          withShoppables: displayOptions.withShoppables,
          withStoryTitle: displayOptions.withStoryTitle,
        }}
      />
    </WidgetWrapper>
  );
};
